import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials, successStories } from '../../data/mock';

const TestimonialsSection = () => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <section className="py-12 bg-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Real stories, real impact
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            See how our community is changing lives every day
          </p>
        </div>

        {/* Success Stories */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {successStories.map((story) => (
            <div
              key={story.id}
              className="group bg-card border border-border rounded-2xl overflow-hidden hover:border-emerald-500/50 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={story.image}
                  alt={story.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block bg-gradient-to-r from-emerald-500 to-teal-600 text-white text-sm font-medium px-3 py-1 rounded-full">
                    {formatCurrency(story.raised)} Raised
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-semibold text-lg text-foreground mb-2 group-hover:text-emerald-400 transition-colors">
                  {story.title}
                </h3>
                <p className="text-emerald-400 font-medium mb-3">{story.impact}</p>
                <div className="flex items-start space-x-2">
                  <Quote className="w-5 h-5 text-muted-foreground flex-shrink-0 mt-0.5" />
                  <p className="text-muted-foreground italic text-sm">"{story.quote}"</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-card border border-border rounded-2xl p-6 hover:border-emerald-500/50 transition-all duration-300"
            >
              {/* Rating */}
              <div className="flex space-x-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-muted-foreground mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
